(() => {
  const gallerySelector = '.made-card__gallery[data-made-gallery]';
  const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const states = new WeakMap();
  const frameDelay = 1050;

  const getFrames = (gallery) => [...gallery.querySelectorAll('[data-made-frame]')];

  const hydrate = (frame) => {
    if (!frame || frame.currentSrc || frame.getAttribute('src')) return Promise.resolve();
    const source = frame.dataset.madeFrameSrc;
    if (!source) return Promise.resolve();
    if (frame.dataset.madeFrameSrcset) frame.srcset = frame.dataset.madeFrameSrcset;
    if (frame.dataset.madeFrameSizes) frame.sizes = frame.dataset.madeFrameSizes;
    frame.src = source;
    return frame.decode?.().catch(() => {}) || Promise.resolve();
  };

  const show = (gallery, frames, index) => {
    frames.forEach((frame, frameIndex) => frame.classList.toggle('is-active', frameIndex === index));
    gallery.style.setProperty('--mi-album-progress', `${((index + 1) / frames.length) * 100}%`);
  };

  const stop = (gallery) => {
    const state = states.get(gallery);
    if (state) {
      state.active = false;
      state.token += 1;
      window.clearTimeout(state.timer);
    }
    const frames = getFrames(gallery);
    if (frames.length) show(gallery, frames, 0);
    gallery.classList.remove('is-album-playing');
    gallery.style.setProperty('--mi-album-progress', '0%');
  };

  const scheduleNext = (gallery, state) => {
    state.timer = window.setTimeout(async () => {
      if (!state.active) return;
      const frames = getFrames(gallery);
      const nextIndex = (state.index + 1) % frames.length;
      const token = state.token;
      await hydrate(frames[nextIndex]);
      if (!state.active || token !== state.token) return;
      state.index = nextIndex;
      show(gallery, frames, nextIndex);
      hydrate(frames[(nextIndex + 1) % frames.length]);
      scheduleNext(gallery, state);
    }, frameDelay);
  };

  const start = async (gallery) => {
    if (!hoverQuery.matches || reducedMotionQuery.matches) return;
    const frames = getFrames(gallery);
    if (frames.length < 2) return;
    stop(gallery);
    const state = { active: true, index: 0, timer: 0, token: 1 };
    states.set(gallery, state);
    gallery.classList.add('is-album-playing');
    show(gallery, frames, 0);
    const token = state.token;
    await hydrate(frames[1]);
    if (!state.active || token !== state.token) return;
    state.index = 1;
    show(gallery, frames, 1);
    hydrate(frames[2] || frames[0]);
    scheduleNext(gallery, state);
  };

  if (document.documentElement.dataset.madeAlbumDelegated !== 'true') {
    document.documentElement.dataset.madeAlbumDelegated = 'true';
    document.addEventListener('pointerover', (event) => {
      if (event.pointerType && event.pointerType !== 'mouse') return;
      const gallery = event.target.closest?.(gallerySelector);
      if (!gallery || gallery.contains(event.relatedTarget)) return;
      start(gallery);
    });
    document.addEventListener('pointerout', (event) => {
      const gallery = event.target.closest?.(gallerySelector);
      if (!gallery || gallery.contains(event.relatedTarget)) return;
      stop(gallery);
    });
    window.addEventListener('pagehide', () => {
      document.querySelectorAll(gallerySelector).forEach(stop);
    });
  }
})();
